import { createContext } from 'react';

export const InvoicesContext = createContext<any>({
  onFinishOnboarding: null,
  initialObStep: null,
  settings: null,
});
